'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlagIconOptionsTypeTcomb = exports.FlagIconPropsTypeTcomb = exports.FlagIconClassesObjectTypeTcomb = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _tcombReact = require('tcomb-react');

var _tcomb = require('tcomb');

var _countries = require('../functions/countries');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var strict = true;

var addKeyToObj = function addKeyToObj(retObj, curObj) {
  return _extends({}, retObj, _defineProperty({}, curObj.code, curObj.name));
};

var countriesKeyValue = (0, _countries.getCountries)().reduce(addKeyToObj, {});

var FlagIconSizeType = _tcomb.enums.of(['lg', '2x', '3x', '4x', '5x'], 'FlagIconSizeType');
var FlagIconRotateType = _tcomb.enums.of([30, 60, 90, 180, 270], 'FlagIconRotateType');
var FlagIconFlipType = _tcomb.enums.of(['horizontal', 'vertical'], 'FlagIconFlipType');
var FlagIconCodeType = (0, _tcomb.enums)(countriesKeyValue, 'FlagIconCodeType');

var FlagIconClassesObjectTypeTcomb = exports.FlagIconClassesObjectTypeTcomb = (0, _tcomb.struct)({
  code: FlagIconCodeType,
  size: (0, _tcomb.maybe)(FlagIconSizeType),
  squared: (0, _tcomb.maybe)(_tcomb.Boolean),
  rotate: (0, _tcomb.maybe)(FlagIconRotateType),
  flip: (0, _tcomb.maybe)(FlagIconFlipType)
}, 'FlagIconClassesObjectType');

var FlagIconPropsTypeTcomb = exports.FlagIconPropsTypeTcomb = FlagIconClassesObjectTypeTcomb.extend({
  Component: (0, _tcomb.maybe)(_tcomb.String),
  children: (0, _tcomb.maybe)(_tcombReact.ReactChildren)
}, { name: 'FlagIconPropsType', strict: strict });

var FlagIconOptionsTypeTcomb = exports.FlagIconOptionsTypeTcomb = (0, _tcomb.struct)({
  useCssModules: _tcomb.Boolean,
  themeStyles: (0, _tcomb.maybe)(_tcomb.Object)
}, { name: 'FlagIconOptionsType', strict: strict });


//////////////////
// WEBPACK FOOTER
// ./~/react-flag-icon-css/lib/types/tcomb.js
// module id = 360
// module chunks = 0